import { Container, Modal } from "react-bootstrap";
import { connect } from "react-redux";
import { baseURL, headers } from "../../../../../global/api";
import { setHeading } from "../../../accounts/account.actions";
import { useEffect, useState } from "react";
import { DeleteReceivingApi, individualPDF } from "./Receiving.action";
import { PDFHeader } from "../../../../../global/globalFunctions";
import { isEmpty } from "lodash";
import MaterialFlavors from 'material-table';
import MaterialTable from "material-table";
import LocalPrintshopIcon from '@mui/icons-material/LocalPrintshop';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import moment from "moment";
import ReplayIcon from '@mui/icons-material/Replay';
import EditIcon from "@mui/icons-material/Edit";
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';


const ReceivingList = (props) => {
  const [showReturnModal, setShowReturnModal] = useState(false);
  const [selectedReturnData, setSelectedReturnData] = useState([]);

  useEffect(() => {
    props.setHeading("Receiving List");
  }, []);

  return (
    <>
      <Container fluid>
        <MaterialFlavors
          title="Receiving List"
          columns={[
            { title: "S.No", field: "sequenceNumber" },
            { title: 'Company Name', field: 'restaurantId.restaurantName' },
            { title: 'Vendor Name', field: 'vendorDetails.vendorName' },
            { title: 'Date', field: 'receivingDate', render: rowData => moment(rowData.receivingDate).format('DD-MM-YYYY') },
            { title: 'Total Bill', field: 'totalBill' },
            { title: 'Discount', field: 'discount' },
            { title: 'Leak Discount', field: 'leakDiscount' },
            { title: 'Tax', field: 'tax' },
            { title: 'Freight', field: 'freight' },
            { title: 'Grand Total', field: 'netPayable' },
            { title: 'Receivied By', field: 'receivedBy' },
            { title: 'Description', field: 'recivingDescription' },
          ]}
          data={(query) =>
            new Promise((resolve, reject) => {
              let url = `${baseURL}/receiving/get-receiving?`;
              url += "limit=" + query.pageSize;
              url += "&page=" + (query.page);
              url += "&search=" + query.search;
              fetch(url, {
                method: 'GET',
                headers: headers,
              }).then((response) => response.json()).then((result) => {
                resolve({
                  data: result.data,
                  page: result.page,
                  totalCount: result.total_results,
                });
              });
            })
          }
          detailPanel={rowData => {
            return (
              <MaterialTable
                columns={[
                  { title: 'Product Name', render: rowData => rowData?.productTypeName === "Simple Product" ? rowData?.productName : `${rowData?.productName} - ${rowData?.productVariationLabel}` },
                  { title: 'Purchase Price', field: 'purchasePrice' },
                  { title: 'Sale Price', field: 'salePrice' },
                  { title: 'Required Quantity', field: 'requiredProductQuantity' },
                ]}
                data={rowData.receivingData}
                options={{
                  actionsColumnIndex: -1,
                  toolbar: false,
                  exportButton: false,
                  sorting: false,
                  paging: false,
                  pageSize: 200,
                  emptyRowsWhenPaging: false,
                  pageSizeOptions: [50, 100, 150, 200],
                  headerStyle: {
                    position: 'sticky', top: 0,
                    color: '#00BBBB',
                    fontWeight: '550',
                    onRowAdd: 'none',
                  }
                }}
              />
            )
          }}
          options={{
            actionsColumnIndex: -1,
            exportButton: true,
            exportAllData: true,
            paging: true,
            pageSize: 50,
            emptyRowsWhenPaging: false,
            pageSizeOptions: [50, 100, 150, 200],
            headerStyle: {
              position: "sticky",
              top: 0,
              color: "#00BBBB",
              fontWeight: "550",
              onRowAdd: "none",
              whiteSpace: 'nowrap',
            },
            rowStyle: {
              whiteSpace: 'nowrap',
            },
            cellStyle: {
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            },
            exportPdf: (columns, data) => {
              const unit = "pt";
              const size = "A4";
              const orientation = "l";
              const doc = new jsPDF(orientation, unit, size);
              PDFHeader(doc, "Receiving Details");

              const columnTitles = columns.map(columnDef => columnDef.title);
              const pdfData = data.map((elt) => [
                elt.sequenceNumber,
                elt.restaurantId.restaurantName,
                elt.vendorDetails.vendorName,
                elt.receivingDate,
                elt.totalBill,
                elt.discount,
                elt.leakDiscount,
                elt.tax,
                elt.freight,
                elt.netPayable,
                elt.receivedBy,
                elt.recivingDescription,
              ]);
              let content = {
                startY: 120,
                startX: 5,
                head: [columnTitles],
                body: pdfData,
                headStyles: { fillColor: "#2980ba", font: 'Amiri', fontSize: 10 },
                styles: { fontSize: 9 },
                theme: "grid",
              };

              doc.setFontSize(11)
              doc.setFont("Times New Roman", "Normal")
              doc.autoTable(content);

              doc.setProperties({ title: 'Receiving Details' })
              doc.output('dataurlnewwindow')
            },
          }}
          actions={[
            (rowData) => ({
              icon: () => <LocalPrintshopIcon />,
              tooltip: "Print Receiving",
              onClick: (event, rowData) => {
                props.individualPDF(rowData);
              },
            }),
            (rowData) => ({
              icon: () => <ReplayIcon />,
              disabled: isEmpty(rowData?.returnData),
              tooltip: "Return Receivings",
              onClick: (event, rowData) => {
                setSelectedReturnData(rowData?.returnData || []);
                setShowReturnModal(true);
              }
            })
          ]}
          editable={{
            isEditable: (rowData) => false,
            onRowUpdate: (newData, oldData) =>
              new Promise((resolve) => {
                setTimeout(() => {
                  resolve();
                  // props.UpdateMachineApi(newData, oldData);
                }, 600);
              }),
            onRowDelete: (oldData) =>
              new Promise((resolve) => {
                setTimeout(() => {
                  resolve();
                  props.DeleteReceivingApi(oldData._id);
                }, 600);
              }),
          }}
          icons={{
            Edit: (props) => <EditIcon {...props} />,
            Delete: (props) => <DeleteOutlineIcon {...props} style={{ color: "#DC3545" }} />
          }}
        />

        <Modal show={showReturnModal} centered size='lg' onHide={() => setShowReturnModal(false)} >
          <Modal.Header closeButton>
            <Modal.Title>Return Receiving Details</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <MaterialTable
              title=""
              columns={[
                { title: "Product Name", field: "productName" },
                { title: "Purchase Price", field: "productPrice" },
                { title: "Return Quantity", field: "returnQuantity" },
              ]}
              data={selectedReturnData}
              options={{
                paging: false,
                search: false,
                sorting: false,
                toolbar: false,
                headerStyle: {
                  color: "#00BBBB",
                  fontWeight: "550",
                },
              }}
            />
          </Modal.Body>
        </Modal>

      </Container>
    </>
  );
};
const mapDispatchToProps = (dispatch) => {
  return {
    setHeading: (data) => dispatch(setHeading(data)),
    individualPDF: (data) => dispatch(individualPDF(data)),
    DeleteReceivingApi: (id) => dispatch(DeleteReceivingApi(id)),
  };
};
const mapStateToProps = (state, ownProps) => ({
  ReceivingList: state.RecivingReducer.ReceivingList,
  isFetchingReceiving: state.RecivingReducer.isFetchingReceiving,
});

export default connect(mapStateToProps, mapDispatchToProps)(ReceivingList);
